module.exports = __webpack_public_path__ + "static/media/8.3784a0d9.jpg";